

export const resetEditJobReducer = (state) => {
    state.editJob.status = "idle";
    state.editJob.errorMessage = "";
}